import * as React from 'react'
import { rwCreatorCheckStepAtom, CREATOR_CHECK_STEP } from '../../atoms/CreatorCheck'
import { useAtom } from 'jotai'

import SpinnerDialog from './SpinnerDialog'

const CREATOR_AUTH_STEP_TITLE_MAP = {
  [CREATOR_CHECK_STEP.NONE]: null,
  [CREATOR_CHECK_STEP.CANCELLED]: null,
  [CREATOR_CHECK_STEP.CHECKING_WHITELIST]: 'Checking whitelist',
  [CREATOR_CHECK_STEP.NOT_WHITELISTED]: null,
  [CREATOR_CHECK_STEP.CHECKING_PENDING_CREATION]: 'Checking pending creation',
}

const CREATOR_AUTH_STEP_DESCRIPTION_MAP = {
  [CREATOR_CHECK_STEP.NONE]: null,
  [CREATOR_CHECK_STEP.CANCELLED]: null,
  [CREATOR_CHECK_STEP.CHECKING_WHITELIST]:
    'Checking if you are approved to post videos on Glass...',
  [CREATOR_CHECK_STEP.NOT_WHITELISTED]: null,
  [CREATOR_CHECK_STEP.CHECKING_PENDING_CREATION]: 'Checking if you have any pending creations.',
}

const CreatorCheckDialog = (): JSX.Element => {
  const [creatorCheckStep, setCreatorCheckStep] = useAtom(rwCreatorCheckStepAtom)
  const title = CREATOR_AUTH_STEP_TITLE_MAP[creatorCheckStep]
  const description = CREATOR_AUTH_STEP_DESCRIPTION_MAP[creatorCheckStep]

  return (
    <SpinnerDialog
      title={title}
      description={description}
      onClose={() => setCreatorCheckStep(CREATOR_CHECK_STEP.NONE)}
    />
  )
}

export default CreatorCheckDialog
